module.exports = __webpack_public_path__ + "static/media/download.64dca5ae.png";